import { shallowEqual } from 'react-redux';
import { useFormContext } from '../form/FormContext';
import { PropsSelectorUndefinedObject } from '@apia/util';
import { useFieldSelector } from '../validationStore';

interface IUseFieldValue {
  formName?: string;
  name: string;
}

export function useFieldValue<T = unknown>({ formName, name }: IUseFieldValue) {
  const { name: hookFormName } = useFormContext();

  if (!formName && !hookFormName) {
    throw new Error(
      `useFieldValue: It was not possible to determine the formName in field with name ${name}`,
    );
  }

  const { value } = useFieldSelector(
    formName ?? hookFormName,
    name,
    (props) => {
      return props;
    },
    (a, b) => {
      if (a === PropsSelectorUndefinedObject && b?.value === undefined)
        return true;
      return shallowEqual(a?.value, b?.value);
    },
  );

  return value as T;
}
